import React from "react";
import LazyLoad from "react-lazyload";
import withTranslator from "../Translator/withTranslation";
import TrustBox from "./Trustpilot.js";
import styled from "@emotion/styled";
import { LoadingAnimation } from "./LoadingAnimation";
import { TrustpilotLocaleMap } from "../Data/APIData";

const ContentContainer = styled.div`
    padding: 4em 1em;
    max-width:1600px;
    margin:auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    
    @media (max-width:767px){
        display:block;
        padding: 4em 0;
    }
`;

const stripTags = (html) => {
    return html.replace(/(<([^>]+)>)/ig,"");
}

const BookingTrustboxInnerComponent = (props) => {
    return (
        <LazyLoad once placeholder={<LoadingAnimation className="width-100"/>}>
            <div className="bg-grey3">
                <ContentContainer>
                    <h2 className="px-3 width-100 text-center font-w600 no-inherit-color blue1">{stripTags(props.t('what_our_guest_say_trustpilot'))}</h2>
                    <TrustBox
                        locale={TrustpilotLocaleMap[props.locale].locale}
                        template={TrustpilotLocaleMap[props.locale].template}
                        businessunit={TrustpilotLocaleMap[props.locale].businessunit}
                        tpurl={TrustpilotLocaleMap[props.locale].tpurl}
                        stars="4,5"
                    />
                </ContentContainer>
            </div>
        </LazyLoad>
    )
}

export const BookingTrustboxInner = withTranslator(BookingTrustboxInnerComponent);
